import { CreativeModel, ICreativeCreateForm, ICreativeEditForm } from '../models/creative.model';
import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import endpoints from './endpoints/index.endpoints';
import { URLSearchParams } from 'url';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export type ids = {
	id: id;
	resource_url?: string;
}[];

export const CreativesApi = {
	list: (options?: URLSearchParams): Promise<CreativeModel[]> => {
		return ask.get(endpoints.creatives.list(), options);
	},
	listByCampaign: (campaignId: id, options?: URLSearchParams): Promise<CreativeModel[]> => {
		return ask
			.get(`${endpoints.creatives.rootApi}/campaigns/${campaignId}/creatives`, options)
			.then((campaignCreatives: CreativeModel[]) => campaignCreatives);
	},
	create: (creative: ICreativeCreateForm, options?: IRequestOptions): Promise<{ id: id }> => {
		return ask.post<ICreativeCreateForm>(endpoints.creatives.create(), creative, options);
	},
	edit: (creativeId: id, creative: ICreativeEditForm, options?: IRequestOptions): Promise<null> => {
		return ask.patch<ICreativeEditForm>(`${endpoints.creatives.edit(creativeId.toString())}`, creative, options);
	},
	get: (creativeId: id, params?: URLSearchParams): Promise<CreativeModel> => {
		return ask.get(`${endpoints.creatives.get(creativeId)}`, params);
	},
	delete: (creativeId: id) => {
		return ask.delete(`${endpoints.creatives.delete(creativeId)}`);
	},
	postBanner: (banners: FormData): Promise<string[]> => {
		return ask.upload(endpoints.creatives.postBanner(), banners);
	},
	sendToReview(creativeIds: id[]) {
		return ask.post(endpoints.creatives.sendToReview(), creativeIds);
	},
	multiCreate: (creatives: ICreativeCreateForm[], options?: IRequestOptions): Promise<ids> => {
		return ask.post<ICreativeCreateForm[]>(endpoints.creatives.multiCreate(), creatives, options);
	},
	bulkCreateCSV: (csvData: FormData) => {
		return ask.upload(endpoints.creatives.bulkCreateCSV(), csvData);
	},
	detachCampaignCreatives: (creativeIds: id[], campaignId: id): Promise<null> => {
		if (!campaignId) {
			throw new TypeError('Campaign id cannot be undefined');
		}
		return ask.delete(`${endpoints.creatives.getCampaignCreatives(campaignId, creativeIds)}`);
	},
};
